import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../../../atomic/Buttons/Button';
import Icon from '@material-ui/core/Icon';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  // width: 100px;
  // height: 100px;
  margin: 7px 0;
  flex: 1 0 auto; 
  // background: rgba(0,0,0,0.3);
`
const TextContainer = styled.div`
  flex: 0 1 auto;
  text-align: center;
  // background: rgba(0,0,0,0.3);
  color: black;
  font-size: 14px;
  margin-top: 4px;
`

const ButtonStyled = styled(Button)`
  width: 40px;
  height: 40px;
  flex: 1 0 auto;
  background: ${props => props.background};
`

const IconStyled = styled(Icon)`
  color: white;
  font-size: 21px;
`

const ButtonWrapper = ({
  text,
  buttonIcon,
  color,
  children,
  ...other
}) => {

  return (
    <Container {...other}>
      <ButtonStyled background={color}>
        <IconStyled>{buttonIcon}</IconStyled>
      </ButtonStyled>
      <TextContainer>{text}</TextContainer>
    </Container>
  )
}

ButtonWrapper.propTypes = {
  text: PropTypes.string.isRequired,
  buttonIcon: PropTypes.string.isRequired,
  color: PropTypes.string,
};

ButtonWrapper.defaultProps = {
  color: 'grey'
}

export default ButtonWrapper;
